"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.2
var Kits = void 0;

var noun_modal = void 0;

noun_modal = require("./noun_modal").default;

Kits = function () {
  function Kits() {
    var authentication = void 0;
    var on_finish = void 0;
    var on_load = void 0;
    var share = void 0;
    var share_modal = void 0;
    share_modal = {
      type: "share",
      style: "full-blur",
      authenticate: false
    };
    on_finish = function on_finish() {
      return (0, _jquery2.default)(".close-button").on("click", function (e) {
        e.preventDefault();
        return noun_modal.dismiss();
      });
    };
  }

  return Kits;
}();

exports.default = Kits;